module.exports = __webpack_public_path__ + "img/n3.aab8dd1c.jpg";